import { URLs } from '../../../lib/constants';

export const excludedPathsForSignInDisclaimer = [URLs.HomePage, URLs.EventPage];
